// extracted by mini-css-extract-plugin
export default {"instructionsContainer":"fK-z","instructionsColumn":"gK-z","columnTitle":"hK-z","secondLine":"iK-z"};